// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3os_L","productName":"Table_productName__3RopR"};